// project-imports
import {
  GET_ENQUIRY_BEGIN,
  GET_ENQUIRY_FAILURE,
  GET_ENQUIRY_SUCCESS,
} from "../constants/actions";

// State variable initialization
export const initialState = {
  isLoading: false,
  error: null,
  enquiryData: [],
};

const enquiryReducer = (state = initialState, action) => {

  if (action.type === GET_ENQUIRY_BEGIN) {
    // Set loading state
    return {
      ...state,
      isLoading: action.payload,
      error: null,
    };
  }

  if (action.type === GET_ENQUIRY_SUCCESS) {

    // Update state with enquiry
    return {
      ...state,
      isLoading: false,
      enquiryData: action.payload,
      error: null,
    };
  }

  if (action.type === GET_ENQUIRY_FAILURE) {
    // Set error state
    return {
      ...state,
      isLoading: false,
      error: action.payload,
    };
  }
  return state;
};

export default enquiryReducer;
